export default function Mission() {
  return (
    <section className="w-full py-20 bg-[#F5E9D8]">
      <div className="max-w-6xl mx-auto text-center px-4" data-aos="fade-up">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1A1F2B]">
          Our Mission
        </h2>
        <p className="text-[#1A1F2B] mt-3 max-w-2xl mx-auto">
          At Moriah Church, Prarthana Bhawan, our mission is to cultivate a
          Christ-centered and Spirit-led environment where people from all walks
          of life can encounter the living God through authentic worship,
          biblical teaching, and fervent prayer.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-14" data-aos="fade-up">
          <div className="p-8 bg-white shadow-md rounded-xl">
            <h3 className="text-xl font-semibold text-[#1A1F2B]">Worship</h3>
            <p className="text-gray-700 mt-2">
              Encountering the living God through authentic worship, prayer, and
              the teaching of His Word.
            </p>
          </div>

          <div className="p-8 bg-white shadow-md rounded-xl">
            <h3 className="text-xl font-semibold text-[#1A1F2B]">Serve</h3>
            <p className="text-gray-700 mt-2">
              Reflecting God’s love through discipleship, service, compassionate
              outreach, and strengthening families.
            </p>
          </div>

          <div className="p-8 bg-white shadow-md rounded-xl">
            <h3 className="text-xl font-semibold text-[#1A1F2B]">Grow</h3>
            <p className="text-gray-700 mt-2">
              Nurturing spiritual maturity, leadership development, and
              empowering believers to live out their faith daily.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
